module.exports = __webpack_public_path__ + "img/results-header.91c81d96.jpg";